import { gql } from "@apollo/client"

export const ALL_FORMATS = gql`
  query allFormats {
    allFormats(orderBy: name_ASC, filter: { status: 1 }) {
      id
      name
      status
      totalTournaments
      FormatGames {
        gameId
        formatId
      }
    }
  }
`
